import { Box, Icon } from "@chakra-ui/react";
import { MdArrowForward } from "react-icons/md";
import LoginLayoutButton from "components/Layout/LoginLayoutButton";
import asyncVoidHandler from "lib/errors/asyncVoidHandler";
import useCountdown from "./useCountdown";

const CHECKOUT_SUCCESS_REDIRECT_DELAY_SECONDS = 5;

type Props = {
  onContinue: () => Promise<void>;
};

export default function SignupCheckoutSuccessContinueButton({
  onContinue,
}: Props) {
  const countdown = useCountdown({
    onComplete: onContinue,
    seconds: CHECKOUT_SUCCESS_REDIRECT_DELAY_SECONDS,
  });

  return (
    <LoginLayoutButton
      onClick={asyncVoidHandler(onContinue)}
      rightIcon={<Icon as={MdArrowForward} mr={-2} />}
    >
      Continue to app in{" "}
      <Box
        as="span"
        className="use-tabular-nums"
        display="inline-block"
        ml={1}
        minWidth="1ch"
        sx={{
          "&.use-tabular-nums": {
            fontVariantNumeric: "tabular-nums",
          },
        }}
      >
        {countdown}
      </Box>
    </LoginLayoutButton>
  );
}
